// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.delete.RentalManagerUserPropertyDeleteWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyDeleteWebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface DeleteParams {
  listingAlias: ListingAlias;
  reason?: string;
}

export interface RentalManagerUserPropertyDeleteWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyDeleteWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDeleteWebApiHandler_delete_Args
>;

/**
 * Delete a property
 */
export const useRentalManagerUserPropertyDeleteWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDeleteWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeleteWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyDeleteWebApiHandler_delete(args.getParams, httpClient),
  });
};
